import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { Edit, PlusCircle } from "feather-icons-react/build/IconComponents";
import Error404 from "MainPages/ErrorPages/error404";
import DeductionFrom from "Components/Modal/deduction";
import { useForm, FormProvider } from "react-hook-form";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";
import { format } from "date-fns";

import { yupResolver } from "@hookform/resolvers/yup";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { deductionValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import {
  useAddDeductionMutation,
  useDeletePayrollDeductionMutation,
  useUpdateDeductionMutation,
} from "AppQuries/payroll/deduction/deduction";
import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
import { Popconfirm, Switch } from "antd";
import { Trash2 } from "react-feather";
import { toast } from "core/Operations/toast";
import ReportTools from "Components/UI/ReportTools";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";

const DeductionList = () => {
  const userData = useSelector(loggedInUser);

  const [isMount, setIsMount] = useState(false);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const methods = useForm({
    resolver: yupResolver(deductionValidationSchema),
  });
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: GetDeductions,
  } = useGetDeductionsQuery({
    companyCode: userData?.companyCode,
    isTrue: showActiveOnly,
  });
  const { mutate: addDeduction } = useAddDeductionMutation();
  const { mutate: updateDeduction } = useUpdateDeductionMutation();
  const { mutate: deleteItem } = useDeletePayrollDeductionMutation();
  const [selectedDeduction, setSelectedDeduction] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const deductionData = data?.data.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const { setSearchValue, filteredData } = useTableSearch(deductionData, [
    "description",
    "haveCpf",
  ]);

  const handleAddClick = () => {
    setSelectedDeduction(null);
    methods.reset({
      companyCode: userData.companyCode,
      description: "",
      haveCpf: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (deduction) => {
    setSelectedDeduction(deduction);
    methods.reset({
      companyCode: deduction.companyCode,
      description: deduction.description,
      haveCpf: deduction.haveCpf,
      createUser: deduction.createUser,
      createDate: deduction.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    if (selectedDeduction) {
      payload.code = selectedDeduction.code;
      updateDeduction(payload, {
        onSuccess: (data) => {
          if (data?.data) {
            toast.success("Deduction Updated Successfully.");

            setSelectedDeduction(null);
            setShow(false);
            GetDeductions();
          } else {
            toast.warning("Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      payload.code = 0;
      addDeduction(payload, {
        onSuccess: (data) => {
          if (data?.data) {
            toast.success("Deduction Added Successfully.");
            setShow(false);
            GetDeductions();
          } else {
            toast.warning(error.message || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteItem(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Item Deleted Successfully.");

          setShow(false);
          GetDeductions();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  useEffect(() => {
    if (isMount) GetDeductions();
    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  const columns = [
    {
      title: "SNo",
      dataIndex: "id",
    },
    {
      title: "Deduction Name",
      dataIndex: "description",
    },
    // {
    //   title: "Have CPF",
    //   dataIndex: "haveCpf",
    //   render: (text, record) => (
    //     <span
    //       className={`badges ${
    //         record.haveCpf ? "bg-lightgreen" : "bg-lightred"
    //       }`}
    //     >
    //       {record.haveCpf ? "Yes" : "No"}
    //     </span>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.payroll_management}
            accessCode={accessCodes.payroll_deduction}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="edit-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleEditClick(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          <Can
            accessModule={accessCodes.payroll_management}
            accessCode={accessCodes.payroll_deduction}
            accessType="haveDelete"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
            >
              <Link className="me-2 p-2" to="#">
                <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => deleteItemHandler(record.code)}
                >
                  <Trash2 className="feather-delete" />
                </Popconfirm>
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Deductions</h4>
                <h6>Manage your Deductions</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Deductions Master"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={GetDeductions}
              />
            </div>
            <div className="page-btn">
              <Can
                accessModule={accessCodes.payroll_management}
                accessCode={accessCodes.payroll_deduction}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add New Deduction</Tooltip>
                  }
                >
                  <Link
                    to="#"
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add New Deduction
                  </Link>
                </OverlayTrigger>
              </Can>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={false}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <Switch
                                checked={showActiveOnly}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) =>
                                  setShowActiveOnly(checked)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Table
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <DeductionFrom
          mode={selectedDeduction ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </div>
  );
};

export default DeductionList;
